import {RoleEnum} from '@pages/global/users/user-types';
import {WorkspaceResource} from '@workspaces/resources';
import {WorkspaceList, workspacesBasePath} from '@workspaces/workspaces';

const basePath = workspacesBasePath[WorkspaceList.BDESE];
export const helpResources: WorkspaceResource[] = [
  {
    name: 'bdese/help',
    create: `${basePath}/subthematics/:subthematicId/helps/new`,
    edit: `${basePath}/subthematics/:subthematicId/helps/edit/:id`,
    list: `${basePath}/subthematics/:subthematicId/helps`,
    meta: {
      label: 'pages.bdese.labels.help',
      prefix: 'pages.bdese.help',
      canDelete: true,
      parent: 'bdese/subthematic',
      accessControl: {
        [RoleEnum.ROLE_ADMIN]: ['edit', 'delete', 'create'],
        [RoleEnum.ROLE_USER]: ['edit', 'delete', 'create'],
      },
    },
  },
  {
    name: 'bdese/help/section/enum',
    meta: {
      label: 'pages.bdese.help.title',
      prefix: 'pages.bdese.help',
      accessControl: {
        [RoleEnum.ROLE_ADMIN]: ['list'],
        [RoleEnum.ROLE_USER]: ['list'],
      },
    },
  },
];
